// TODO removed because of ts conflicts // import { Dictionary } from "@ngrx/entity"
import { flatten, jsonCopyObject, makeMapFromListOfObjectsAndKey, typedValues } from "../../globals/helpers/helpers"
import { JoiEvent, LabelObject } from "./events.data"
import { getExhibitorStandIdsByProgramId, Program, ProgramLogisticsDisplayOptions, Session, sortPrograms } from "./programs.data"
import { BrandingData } from "./publish.data"
import { LogisticsShareable } from "./share.data"
import { TagPanelData, getAllTagPanelData } from "./tags.data"
import { filterPrograms } from "./reselectors/filteredPrograms.reselector"
import publicHelpers from "../../globals/helpers/public-helpers"
import { Dictionary } from "./app.data";

export type LogisticsEventKey = "eventId" | "title" | "performers" | "exhibitorStands" | "exhibitors" | "standTypes" | "assets" | "sponsors" | "venues" | "session_labels" | "program_labels" | "resources" | "workforce" | "attendees"
export const logisticsEventKeys: LogisticsEventKey[] = ["eventId", 'title', "performers", "exhibitorStands", "exhibitors", "standTypes", "assets", "sponsors", "venues", "session_labels", "program_labels", "resources", "workforce", 'attendees']
export type LogisticsEvent = Pick<JoiEvent, LogisticsEventKey>
export interface LogisticsShareData { // does not need to be saved to shareable but instead provided by functions
  logisticsEvent: LogisticsEvent
  canViewStagingRequests: boolean
  programs: Program[]
  program_labels: LabelObject
  session_labels: LabelObject
  exhibitorStandIdsByProgramId: Dictionary<string[]>
  tagDataMap: Dictionary<TagPanelData>
  sessionMap: Dictionary<Session>
}

export const transformEventToLogisticsEvent = (event: JoiEvent): LogisticsEvent => {
  // so... workforce tag ids are by email, so have to include emails from workforce.  Not sure yet how to filter other entities (performers / sponsors / exhibitors /etc)

  const logisticsEvent = {}
  logisticsEventKeys.forEach(k => logisticsEvent[k] = event[k] || null) 
  return logisticsEvent as LogisticsEvent
}
// TODO put getLogisticsShareData somewhere different because this is not just a type!
export const getLogisticsShareData = (fullEvent: JoiEvent, allPrograms: Program[], originalShare: LogisticsShareable): FullLogisticsShareData => {

  // console.log({ share, hasFullEvent: !!fullEvent })
  if (!originalShare || !allPrograms?.length || !fullEvent) return { selectedShare: null, shareData: null }
  // console.log(`N programs before sort: ${allPrograms.length}`)

  const share = jsonCopyObject(originalShare)
  const programsArray = sortPrograms(fullEvent.programOrder, allPrograms)
  // console.log(`N programs after sort: ${programsArray.length}`)

  if (!programsArray || programsArray.length === 0) throw new Error("No programs")

  const programs = filterPrograms(jsonCopyObject(programsArray), share.filters || { count: 0 }) || []
  // console.log(`N programs after filter: ${programs.length}`)

  
  const excludedIds = (share.excludedFieldIds || []) as ProgramLogisticsDisplayOptions[]
  // console.log({ excludedIds })
  if (!programs?.length) return null

  // console.log("Beginning of fullEvent: " + JSON.stringify(fullEvent).slice(0,100))
  const logisticsEvent = transformEventToLogisticsEvent(jsonCopyObject(fullEvent));
  // console.log("Beginning of lgoisticsEvent: " + JSON.stringify(fullEvent).slice(0,100))

  if (share.noURLs) {
    Object.values(logisticsEvent.assets || {}).forEach(a => a.link = null)
  }

  excludedIds.forEach((po) => {
    switch (po) {
      case ProgramLogisticsDisplayOptions.eventTitle:
        delete logisticsEvent.title
        break
      case ProgramLogisticsDisplayOptions.viewName:
        delete share.title
        break
      case ProgramLogisticsDisplayOptions.viewDescription:
        delete share.description
        break
      case ProgramLogisticsDisplayOptions.venueDetails:
        logisticsEvent.venues = {}
        break
      case ProgramLogisticsDisplayOptions.roomExhibitors:
        logisticsEvent.exhibitorStands = {}
        break
      default:
        break
    }
  })
  

  programs.forEach(p => {
    excludedIds.forEach((po) => {
      switch (po) {
        case ProgramLogisticsDisplayOptions.roomDate:
          delete p.date 
          break
        case ProgramLogisticsDisplayOptions.assets:
          p.assetIds = []
          break
        case ProgramLogisticsDisplayOptions.venueDetails:
          p.venueId = null
          break
        case ProgramLogisticsDisplayOptions.roomTags:
          p.sponsorTags = []
          p.resourceTags = []
          p.exhibitorTags = []
          p.performerTags = []
          p.workforceTags = []
          p.attendeeTags = []
          break        
        default: 
          break
      }
    })
    if (share.noURLs) {
      (p.files || []).forEach(f => f.linkUrl = null)
    }
    if (share.excludedFieldIds.includes('setupTab')) {
      p.setups = {}
      p.setupIds = []
    } else {
      Object.values(p.setups || {}).forEach(setup => {
        excludedIds.forEach((po) => {
          switch (po) {
            case ProgramLogisticsDisplayOptions.expectedNumbers:
              setup.expected = null
              break
            case ProgramLogisticsDisplayOptions.capacity:
              setup.capacity = null
              break
            case ProgramLogisticsDisplayOptions.roomSetup:
              setup.setup = null
              break
            case ProgramLogisticsDisplayOptions.setupNotes:
              setup.notes = []
              break
            case ProgramLogisticsDisplayOptions.setupSessions:
              setup.sessionIds = []
              break
            case ProgramLogisticsDisplayOptions.setupAssets:
              setup.assetIds = []
              break
            case ProgramLogisticsDisplayOptions.access:
              setup.access = null
              break
            case ProgramLogisticsDisplayOptions.clear:
              setup.clear = null
              break
            default: 
              break
          }
        })
        if (share.noURLs) {
          (setup.notes || []).forEach(n => (n.files || []).forEach(f => f.linkUrl = null))
        }
      })
    }
    if (excludedIds.includes(ProgramLogisticsDisplayOptions.sessionsTab)) {
      p.sessions_obj = {}
      if (p.sessions) p.sessions.forEach(programDay => programDay.sessions = [])
    } else {
      Object.values(p.sessions_obj || {}).forEach(session => {
        excludedIds.forEach((po) => {
          switch (po) {
            case ProgramLogisticsDisplayOptions.duration:
              session.duration = null
              break
            case ProgramLogisticsDisplayOptions.stagingNotes:
              session.notes = null
              break
            case ProgramLogisticsDisplayOptions.stagingItems:
              session.stagingItems = []
              break
            case ProgramLogisticsDisplayOptions.stagingFiles:
              session.files = []
              break
            case ProgramLogisticsDisplayOptions.cateringNotes:
              session.cateringNotes = null
              break
            case ProgramLogisticsDisplayOptions.cateringItems:
              session.cateringItems = []
              break
            case ProgramLogisticsDisplayOptions.cateringFiles:
              session.cateringFiles = []
              break
            case ProgramLogisticsDisplayOptions.stagingRequests:
              session.stagingRequests = []
              break
            case ProgramLogisticsDisplayOptions.publicLinks:
              session.publicLinks = []
              break
            case ProgramLogisticsDisplayOptions.performers:
              session.performerIds = []
              break
            case ProgramLogisticsDisplayOptions.presentationAssets:
              session.presentationAssets = []
              session.presentationAssetIds = []
              break
            case ProgramLogisticsDisplayOptions.sponsors:
              session.sponsorIds = []
              break
            case ProgramLogisticsDisplayOptions.sessionTags:
              session.tags = []
              session.groupTags = []
              session.sponsorTags = []
              session.performerTags = []
              session.resourceTags = []
              session.exhibitorTags = []
              session.attendeeTags = []
              break
            default: break
          }
        })
        if (share.noURLs) {
          (session.stagingItems || []).forEach(i => (i.files || []).forEach(f => f.linkUrl = null));
          (session.cateringItems || []).forEach(i => (i.files || []).forEach(f => f.linkUrl = null));
          (session.presentationNotes || []).forEach(n => (n.files || []).forEach(f => f.linkUrl = null));
          (session.files || []).forEach(f => f.linkUrl = null);
        }
      })
    }
  })


  const workforce = logisticsEvent.workforce
  const shareData: LogisticsShareData = { 
    logisticsEvent,
    canViewStagingRequests: !excludedIds.includes(ProgramLogisticsDisplayOptions.stagingRequests),
    programs,
    program_labels: publicHelpers.makeLabelMap(logisticsEvent.program_labels),
    session_labels: publicHelpers.makeLabelMap(logisticsEvent.session_labels),
    exhibitorStandIdsByProgramId: excludedIds.includes(ProgramLogisticsDisplayOptions.roomExhibitors) ? {} : getExhibitorStandIdsByProgramId(logisticsEvent.exhibitorStands),
    tagDataMap: getAllTagPanelData(programs, null, makeMapFromListOfObjectsAndKey(workforce, 'email'), logisticsEvent.performers, logisticsEvent.sponsors, logisticsEvent.exhibitors, logisticsEvent.resources, logisticsEvent.attendees || {}, true),
    sessionMap: makeMapFromListOfObjectsAndKey(flatten(programs.map(p => typedValues(p.sessions_obj))), 'id'),
  }
  // console.log(data) 
  return { shareData, selectedShare: share }
}

export interface FullLogisticsShareData {
  brandingData?: BrandingData
  selectedShare: LogisticsShareable
  shareData: LogisticsShareData
}

